var _g, _g2, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _rect2, _rect3, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _rect4, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCat = function SvgCat(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 420,
    height: 369,
    fill: "none",
    viewBox: "0 0 420 369",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg-2489810498__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 220.5,
    cy: 132.5,
    r: 44.5,
    fill: "#FFE4D6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg-2489810498__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 165,
    r: 22,
    fill: "#FFE2D1"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg-2489810498__c)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 91.67,
    height: 91.67,
    x: 123,
    y: 104.353,
    fill: "#fff",
    fillOpacity: 0.7,
    rx: 20,
    transform: "rotate(-20 123 104.353)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE9E6",
    fillRule: "evenodd",
    d: "M186.188 159.378c-5.013.725-8.975-3.922-13.237-6.652-4.109-2.632-8.166-5.075-11.123-8.953-3.799-4.982-9.582-10.282-8.203-16.391 1.379-6.104 9.359-7.638 14.455-11.285 4.484-3.211 8.053-8.334 13.554-8.765 5.487-.429 10.119 3.518 14.704 6.554 4.369 2.892 9.562 5.552 11.125 10.547 1.525 4.877-1.266 9.889-3.258 14.596-1.669 3.942-4.408 7.018-7.248 10.225-3.347 3.781-5.767 9.401-10.769 10.124",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#402C28",
    d: "M180.156 119.49c2.33-.493 9.575-2.352 14.083.535s9.946 5.087 9.79 9.076c-.186 4.868 1.192 17.345-9.402 23.937s-22.72.016-26.223-3.914a14.4 14.4 0 0 1-3.73-10.043c.07-6.309 1.874-11.989 3.356-13.951 2.604-3.517 9.797-5.143 12.126-5.64"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3A4144",
    d: "M179.069 115.799c2.33-.493 12.517-2.129 17.028.769 4.512 2.898 9.629 7.553 9.483 11.538-.191 4.866-1.046 17.107-11.626 23.694s-25.626 3.107-29.128-.822c-1.719-1.922-3.4-7.216-3.357-12.138.057-6.301 4.38-12.984 5.846-14.959 2.626-3.496 9.427-7.582 11.754-8.082"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__d)",
    d: "M179.069 115.799c2.33-.493 11.347-2.243 15.852.646 1.693 1.086 4.644 2.548 6.195 3.998 2.588 2.425 4.551 5.175 4.456 7.67-.192 4.866-1.046 17.106-11.627 23.694s-25.617 3.1-29.119-.829c-1.057-1.182-2.08-3.64-2.738-6.487-.393-1.793-.277-4.462-.268-6.356.057-6.301 4.023-12.265 5.491-14.234 2.631-3.516 9.431-7.602 11.758-8.102"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__e)",
    d: "M179.457 114.178c2.33-.493 12.133-.498 16.644 2.4 4.512 2.898 7.58 5.449 6.535 11.433-.661 3.792-5.4 12.038-13.158 17.017-10.491 6.732-22.937 6.171-25.543 2.881-1.598-2.018-2.509-4.147-2.466-9.069.061-6.291 3.526-13.952 5-15.926 2.61-3.509 10.651-8.262 12.988-8.736"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__f)",
    d: "M194.862 115.9s-5.987-7.501-14.251-12.331a88 88 0 0 1-1.525 10.699s4.593 3.204 15.776 1.632"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__g)",
    d: "M156.069 119.63s6.288 2.033 10.4 3.283c0 0 .68 7.395-4.957 15.413-.023.009-5.712-7.646-5.443-18.696"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#494D4C",
    d: "M193.908 121.21s-6.016.363-8.43 2.502.134 9.763.134 9.763a9.3 9.3 0 0 1 1.669-1.316c1.297-.884 5.079-1.381 5.994-4.484.559-2.107.772-4.29.633-6.465M180.428 136.578s-3.282-3.066-5.094-3.69-3.554-.971-5.563 1.689a23.9 23.9 0 0 0-3.044 5.448s1.513.581 4.289 1.344 4.159.094 5.737-1.522c.846-.87 2.074-3.075 3.675-3.269"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__h)",
    d: "M193.316 123.059s.548 3.786-1.309 6.025c-1.857 2.238-6.016 2.944-6.016 2.944s-2.422-4.821.548-7.619 6.777-1.35 6.777-1.35"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__i)",
    d: "M183.852 136.395c1.93-.992 2.565-.884 3.418-.428 1.044.556.71 3.64-.677 4.692-1.685 1.281-5.243-.19-4.939-1.656.223-1.066 1.36-2.174 2.198-2.608"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__j)",
    d: "M179.316 136.311s-3.609-3.695-6.82-2.696c-3.313 1.028-4.705 6.109-4.705 6.109a8.12 8.12 0 0 0 6.897.796c2.065-.673 4.628-4.209 4.628-4.209"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__k)",
    d: "M188.373 123.195s2.308 1.156 2.742 5.119c0 0-2.611-1.99-3.709-4.594q.469-.29.967-.525"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__l)",
    d: "M173.237 133.463s1.44 1.053 2.326 4.712c0 0-2.874-1.501-3.772-4.288z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1E20",
    d: "M193.317 123.059a10.5 10.5 0 0 0-1.777-.183 9 9 0 0 0-1.756.122 5.23 5.23 0 0 0-3.009 1.54 4.8 4.8 0 0 0-1.502 2.996 12.6 12.6 0 0 0 .321 3.525 9.2 9.2 0 0 1-.733-3.556c.022-.63.172-1.25.44-1.82a5.7 5.7 0 0 1 1.096-1.531c.439-.451.955-.82 1.523-1.091a5.8 5.8 0 0 1 1.799-.481 8.1 8.1 0 0 1 3.598.479M178.348 135.455a12 12 0 0 0-1.533-.914 9 9 0 0 0-1.636-.638 4.4 4.4 0 0 0-3.307.248 6.8 6.8 0 0 0-2.394 2.431c-.638.986-1.129 2.083-1.69 3.143.171-.564.371-1.135.574-1.718a14 14 0 0 1 .755-1.649 6.5 6.5 0 0 1 2.506-2.685 4.1 4.1 0 0 1 1.83-.478 5.2 5.2 0 0 1 1.839.304 8.15 8.15 0 0 1 3.056 1.956"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__m)",
    d: "M183.154 135.099c2.473-1.346 3.232-1.313 4.19-.929 1.188.462.362 3.865-1.463 5.197-2.217 1.622-6.336.51-5.764-1.125.426-1.204 1.942-2.564 3.037-3.143"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#343B3D",
    d: "m184.684 137.421-.445.286 1.322 2.055.444-.286z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#343B3D",
    d: "M187.786 136.13a3.87 3.87 0 0 1-.518 2.03 4.5 4.5 0 0 1-1.468 1.565 4.3 4.3 0 0 1-2.018.677 4 4 0 0 1-2.063-.381 5.46 5.46 0 0 0 3.807-.759 5.2 5.2 0 0 0 1.4-1.336 5.8 5.8 0 0 0 .86-1.796"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__n)",
    d: "M184.179 123.751c-3.506 2.706.459 10.592.459 10.592s-.63.064-3.059 1.967c0 0-5.027-6.896-8.662-5.728.007-.002 3.86-6.918 11.262-6.831"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0AE94",
    d: "M187.791 133.573q-1.194.282-2.345.71c-.754.276-1.481.623-2.171 1.036a10.2 10.2 0 0 0-1.884 1.478 12 12 0 0 0-1.549 1.884 6.7 6.7 0 0 1 1.244-2.162 7.8 7.8 0 0 1 1.912-1.651 9 9 0 0 1 2.324-.977 8.5 8.5 0 0 1 2.469-.318"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__o)",
    d: "M184.179 123.751s-3.899-6.223-7.869-8.243c0 0-4.59 2.071-7.059 4.536 0 0 1.885 6.828 3.673 10.536 0 0 3.455-5.322 11.255-6.829"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__p)",
    d: "M186.789 125.262c1.561-1.289 4.361.854 1.764 3.509-2.097 2.107-4.128-1.554-1.764-3.509",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__q)",
    d: "M171.325 135.011c1.561-1.289 4.821 1.404 1.764 3.509-1.887 1.306-4.128-1.554-1.764-3.509",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__r)",
    d: "M185.23 136.003s-.15 1.474-.53 2.11c0 0-1.599-.172-1.971-.501s2.266-2.161 2.501-1.609"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__s)",
    d: "M180.611 103.569s3.24 7.346 4.788 9.069 6.917 1.898 6.917 1.898a15.7 15.7 0 0 0-4.176-5.782c-2.989-2.581-7.529-5.185-7.529-5.185"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__t)",
    d: "M156.069 119.63s6.293 6.194 6.4 8.657-1.882 6.647-1.882 6.647a15.75 15.75 0 0 1-3.801-7.164 28.1 28.1 0 0 1-.717-8.14"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#9D9286",
    d: "M197.447 130.157c-.761.179-1.516.408-2.261.661-.746.252-1.48.538-2.207.844a30 30 0 0 0-4.192 2.179 29.6 29.6 0 0 1 4.153-2.266 33 33 0 0 1 2.198-.899 23 23 0 0 1 2.264-.714zM196.975 134.782a12.4 12.4 0 0 0-1.953-.474 13 13 0 0 0-2.011-.185 10.5 10.5 0 0 0-3.975.661 10.5 10.5 0 0 1 3.976-.794q1.024-.012 2.038.126 1.024.127 2.011.423zM172.673 145.85c.5-.62 1.039-1.201 1.592-1.765a31 31 0 0 1 1.726-1.624 30 30 0 0 1 3.795-2.835 30 30 0 0 0-3.725 2.911 33 33 0 0 0-1.685 1.655 23 23 0 0 0-1.54 1.783zM177.013 147.436c.37-1.293.852-2.551 1.439-3.761a19.6 19.6 0 0 1 2.088-3.429 19.4 19.4 0 0 0-2.002 3.469 23 23 0 0 0-1.338 3.767z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#F39786",
    d: "M162.256 128.643a9 9 0 0 0-.693-1.23 8 8 0 0 0-.889-1.115 4.6 4.6 0 0 0-2.434-1.431 4.7 4.7 0 0 1 2.604 1.256q.553.496 1.014 1.076.462.586.827 1.235zM162.337 129.508a15 15 0 0 0-1.491-.631 8 8 0 0 0-.773-.239 3.5 3.5 0 0 0-.797-.114q.411-.053.821-.004.415.037.823.123.814.164 1.605.419zM184.569 111.967a13 13 0 0 1 .009-1.728q.027-.433.107-.858a3.1 3.1 0 0 1 .258-.815c-.084.27-.13.55-.139.832q-.015.42.015.84.059.838.227 1.661zM185.551 112.923q.27-.819.666-1.582.197-.38.449-.726c.163-.235.378-.429.627-.568a1.7 1.7 0 0 0-.523.636q-.192.368-.322.762-.274.781-.424 1.596z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#4E5251",
    d: "M190.704 114.41a12 12 0 0 1-2.936-.313 7.6 7.6 0 0 1-1.424-.478 3.55 3.55 0 0 1-1.246-.924 13 13 0 0 1-1.566-2.532 21.5 21.5 0 0 1-1.124-2.723l1.455 2.546q.706 1.254 1.597 2.385c.295.352.663.635 1.079.83q.642.314 1.324.526 1.4.428 2.841.683M159.04 122.742c.801.7 1.529 1.479 2.175 2.325a7.25 7.25 0 0 1 1.46 2.903 7.9 7.9 0 0 1-.447 3.22c-.326 1.018-.754 2-1.276 2.932a38 38 0 0 0 .918-3.025q.19-.757.295-1.53c.078-.504.09-1.015.035-1.522a4.8 4.8 0 0 0-.514-1.413 14 14 0 0 0-.771-1.35 38 38 0 0 0-1.875-2.54"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 89.97,
    height: 89.97,
    x: 124.089,
    y: 104.861,
    stroke: "url(#svg-2489810498__u)",
    strokeOpacity: 0.6,
    strokeWidth: 1.7,
    rx: 19.15,
    transform: "rotate(-20 124.089 104.861)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg-2489810498__v)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg-2489810498__w)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 93.413,
    height: 93.413,
    x: 208.382,
    y: 99.017,
    fill: "#fff",
    fillOpacity: 0.7,
    rx: 20,
    transform: "rotate(17.035 208.382 99.017)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAE9E6",
    fillRule: "evenodd",
    d: "M211.775 174.218c-2.873-4.744.12-10.725 1.051-16.187.899-5.268 1.628-10.402 4.275-15.04 3.399-5.958 6.272-14.054 13.02-15.273 6.744-1.217 11.7 6.173 17.554 9.751 5.152 3.15 11.843 4.559 14.627 9.922 2.777 5.348.777 11.705-.325 17.624-1.049 5.641-1.512 12.012-5.881 15.722-4.264 3.622-10.51 2.949-16.107 2.952-4.687.002-8.959-1.446-13.405-2.939-5.242-1.759-11.942-1.798-14.809-6.532",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__x)",
    d: "M227.971 169.155s-.479 3.845-.378 4.952c0 0 7.815 3.431 14.452 3.906s10.645-.405 10.645-.405l2.53-6.819z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#B35E54",
    d: "M253.673 145.187s1.189-8.262 1.71-9.972l15.756 11.253s-9.031 3.504-16.021 6.46c-6.989 2.956-1.445-7.741-1.445-7.741"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__y)",
    d: "M254.285 145.322s.577-8.397 1.098-10.107l15.756 11.253s-12.917 4.997-13.402 4.383a38.4 38.4 0 0 1-3.452-5.529"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#B35E54",
    d: "M233.408 143.99s-.383-6.677-1.333-9.96c-.118-.406-10.256 13.648-10.555 13.954-.299.305 4.784 5.424 6.737 6.725 1.952 1.3 4.777-9.367 5.151-10.719"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__z)",
    d: "M232.707 144.34s.007-7.483-.633-10.297c-.096-.413-2.01 2.297-3.045 9.481-.061.421-1.589 9.652-.523 7.588.438-.886 3.827-5.434 4.201-6.772"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__A)",
    d: "M257.335 158.206a42 42 0 0 1-2.767-11.892s-8.279-3.235-10.365-3.995c-2.085-.761-11.701 1.954-11.701 1.954s-2.372 5.886-5.511 12.849c-3.179 7.062-6.207 10.861-6.207 10.861 1.591.848 5.011 1.571 7.296 2.649-1.962-.428-4.42-.997-4.42-.997 3.661 1.715 11.746 5.084 17.636 5.61 2.374.212 15.034-.734 20.986-5.08-1.662-4.508-4.947-11.959-4.947-11.959"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__B)",
    d: "M243.082 146.013c-5.126.069-8.12.464-12.463 4.811l-1.132 5.091s5.752 10.78 11.365 11.453c3.307.397 9.053-1.667 12.108-5.241 2.136-2.495 2.268-6.849 2.268-6.849l-.934-5.308c-1.315-2.125-7.327-4.01-11.212-3.957"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__C)",
    d: "M234.377 159.972s1.848 12.161 13.656 20.069c1.853 1.24 9.069-6.612 10.186-8.533 1.118-1.92-19.291-10.565-23.842-11.536"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__D)",
    d: "M244.391 153.538s-4.732 8.931-10.017 6.443c0 0 3.19 9.506 12.372 14.562 0 0 4.389-2.017 7.74-3.286 0 0 2.271 3.021 2.729 2.879s8.826-9.484 10.011-11.037c0 0-14.864-6.45-19.379-9.289.006-.018.907-1.339-3.456-.272"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__E)",
    d: "M244.391 153.538s-4.261 6.852-10.017 6.443c0 0 6.222 9.949 12.941 11.703 0 0 4.336-.115 7.156-.976 0 0 3.727.456 4.184.317s7.389-6.382 8.576-7.944c0 0-15.089-7.079-19.606-9.92.008.016-.915-.267-3.234.377"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__F)",
    d: "M244.391 153.538s-.577 6.541-.73 8.606c0 0 7.561 3.842 10.357 4.564l10.743-4.154s-14.143-7.662-17.128-9.377c0 0-.349-.727-3.242.361"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__G)",
    d: "M243.661 162.144s3.808 5.126 10.828 9.104c0 0 7.847-4.714 10.284-8.69 0 0-8.829-3.329-21.112-.414"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__H)",
    d: "M263.144 162.065c-2.929-.756-9.59-1.954-18.076-.228 5.511 4.169 12.901 4.127 18.076.228"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__I)",
    d: "M245.068 161.837q-.697.141-1.401.309s3.808 5.126 10.828 9.103c0 0 7.847-4.713 10.284-8.689 0 0-.585-.222-1.627-.499-5.183 3.903-12.573 3.945-18.084-.224"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__J)",
    d: "M232.075 134.03s-.902 5.182-3.633 13.178c-1.968 5.751-3.689 8.982-3.689 8.982s-7.929-5.03-13.175-10.288a62.7 62.7 0 0 1 9.527-6.784c5.745-3.372 11.983-5.41 10.97-5.088"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__K)",
    d: "M255.383 135.215c.855.61 2.313 5.731 3.35 9.443 1.037 3.713 2.868 11.07 3.077 11.39s7.078-3.575 11.665-8.346a53 53 0 0 0-8.407-7.296 50.8 50.8 0 0 0-9.685-5.191"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__L)",
    d: "M249.65 178.566c-3.047-.212-7.69-5.689-7.69-5.689s4.083 2.051 4.794 2.171c1.57.271 5.566-2.53 6.698-2.452.493.033 1.388 1.128 1.961 1.677.113.11-4.483 4.38-5.763 4.293"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__M)",
    d: "M244.391 153.538s-1.44-5.853-5.731-8.719c0 0 3.677-1.875 4.647-1.814 1.775.111 6.097 2.259 6.097 2.259s-2.668 2.557-1.771 7.913a8.3 8.3 0 0 0-3.242.361"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#F2E6DB",
    d: "M232.501 144.277s6.295 2.305 10.632 2.601c3.843.246 11.435-.563 11.435-.563s-9.316-3.708-10.537-4.082-5.532.618-11.53 2.044",
    style: {
      mixBlendMode: "overlay"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#556A7A",
    d: "M252.77 162.351c-3.469-1.605-8.831.43-5.349 1.696s6.591-1.123 5.349-1.696",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__N)",
    d: "M232.813 151.978s1.618 2.402 3.352 2.53 3.416-2.293 3.416-2.293-1.667-2.636-2.758-2.721c-2.172-.16-4.01 2.484-4.01 2.484"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__O)",
    d: "M236.838 149.499c-2.738-.101-2.299 3.74-.213 3.89 2.566.186 1.993-3.827.213-3.89"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__P)",
    d: "M234.23 151.038c-.982.585-.7 2.554 1.266 1.785 1.578-.621.561-2.865-1.266-1.785",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E320A",
    d: "M232.822 151.83a38 38 0 0 1 1.843-1.167 7 7 0 0 1 1.905-.813 2.2 2.2 0 0 1 .474-.045l.051.015.051.016.08.024q.102.032.194.083.43.26.766.631c.496.516.92 1.092 1.379 1.672a6.7 6.7 0 0 0-1.021-1.995 3.2 3.2 0 0 0-.854-.816 1.6 1.6 0 0 0-.307-.14 2 2 0 0 0-.179-.055l-.077-.024-.081-.004a2.2 2.2 0 0 0-.612.058 4.2 4.2 0 0 0-1.086.412 7 7 0 0 0-.95.607 8.7 8.7 0 0 0-1.576 1.541"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__Q)",
    d: "M248.774 152.214s1.018-2.427 2.257-2.742c1.569-.399 3.326 2.255 3.326 2.255s-.87 1.932-2.197 2.181c-1.25.243-3.386-1.694-3.386-1.694"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__R)",
    d: "M251.385 149.456c-.74-.034-1.654.933-1.31 2.144.345 1.21 2.165 2.027 2.731.679.567-1.348.329-2.746-1.421-2.823"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__S)",
    d: "M249.591 150.963c-.7.805-.439 2.276 1.395 1.555 1.477-.577-.297-2.813-1.395-1.555",
    style: {
      mixBlendMode: "color-dodge"
    }
  }), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E320A",
    d: "M248.953 151.833a9.5 9.5 0 0 1 1.159-1.419c.419-.407.915-.704 1.42-.671a2.96 2.96 0 0 1 1.494.73q.71.589 1.337 1.266a5.5 5.5 0 0 0-1.051-1.578 3.8 3.8 0 0 0-.756-.625 2.26 2.26 0 0 0-.978-.346 1.78 1.78 0 0 0-1.055.244 2.8 2.8 0 0 0-.755.674 4.3 4.3 0 0 0-.815 1.725"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 91.713,
    height: 91.713,
    x: 208.946,
    y: 100.079,
    stroke: "url(#svg-2489810498__T)",
    strokeOpacity: 0.6,
    strokeWidth: 1.7,
    rx: 19.15,
    transform: "rotate(17.035 208.946 100.079)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg-2489810498__U)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#svg-2489810498__V)",
    fillRule: "evenodd",
    d: "m227.017 95.16.836-.847c1.263-1.28 3.268-2.296 5.054-2.296 1.785 0 3.497.719 4.76 1.997l.379.385a6.87 6.87 0 0 1 1.971 4.824c0 1.81-.709 3.545-1.971 4.823l-2.756 2.794.557-.565-5.114 5.183a5.205 5.205 0 0 1-7.43 0l-6.478-6.565-.836-.847a6.86 6.86 0 0 1-1.972-4.823c0-1.81.709-3.544 1.972-4.824l.38-.385a6.68 6.68 0 0 1 4.758-1.997c1.786 0 3.791 1.016 5.054 2.294z",
    clipRule: "evenodd"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg-2489810498__W)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.237,
    height: 36.237,
    x: 128.264,
    y: 166.689,
    fill: "url(#svg-2489810498__X)",
    rx: 12,
    transform: "rotate(-16.084 128.264 166.689)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD0B8",
    d: "M153.759 177.978a4.62 4.62 0 0 0-4.396-.682 4.62 4.62 0 0 0-2.93 3.348l-.944 4.259a2.73 2.73 0 0 0 1.311 2.959 2.69 2.69 0 0 0 3.195-.396v-.001a7.13 7.13 0 0 1 5.421-1.972 2.69 2.69 0 0 0 2.701-1.75 2.73 2.73 0 0 0-.897-3.11zM144.576 181.134c.851-.729.846-2.105-.011-3.073s-2.241-1.162-3.091-.433-.845 2.105.011 3.073c.857.967 2.241 1.162 3.091.433M147.654 177.475c1.297-.473 1.903-2.083 1.352-3.597s-2.05-2.359-3.348-1.887c-1.297.473-1.903 2.083-1.352 3.598.551 1.513 2.05 2.358 3.348 1.886M152.672 176.861c1.358-.028 2.413-1.371 2.355-2.999s-1.208-2.926-2.566-2.898c-1.359.028-2.413 1.371-2.355 2.999.059 1.628 1.208 2.925 2.566 2.898M158 174.084c-1.129-.306-2.38.49-2.795 1.781-.413 1.29.167 2.586 1.294 2.893s2.38-.49 2.795-1.78c.414-1.291-.166-2.586-1.294-2.894"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 35.419,
    height: 35.419,
    x: 128.77,
    y: 166.968,
    stroke: "#fff",
    strokeOpacity: 0.22,
    strokeWidth: 0.818,
    rx: 11.591,
    transform: "rotate(-16.084 128.77 166.968)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__d",
    x1: 189.356,
    x2: 168.224,
    y1: 152.842,
    y2: 119.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444C4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3A4144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__f",
    x1: 185.278,
    x2: 175.483,
    y1: 120.012,
    y2: 104.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#615F58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69655D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__g",
    x1: 26462.1,
    x2: 26112.3,
    y1: -15646.7,
    y2: -16607.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4F4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#615F58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69655D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__k",
    x1: 186.811,
    x2: 183.631,
    y1: 129.073,
    y2: 124.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1C11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4D3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__l",
    x1: 5330.04,
    x2: 5301.17,
    y1: -3319.42,
    y2: -3398.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C1C11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F4D3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__n",
    x1: 179.181,
    x2: 173.183,
    y1: 135.841,
    y2: 126.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6C2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__p",
    x1: 184.328,
    x2: 182.169,
    y1: 129.547,
    y2: 126.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F433F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__q",
    x1: 10508.6,
    x2: 10493.4,
    y1: -4840.04,
    y2: -4882.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F433F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__r",
    x1: 180.37,
    x2: 179.342,
    y1: 138.899,
    y2: 137.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#482424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#733939"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__s",
    x1: 179.385,
    x2: 183.679,
    y1: 113.695,
    y2: 107.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#CA605A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D86A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ED7862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57D64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__t",
    x1: 12397.3,
    x2: 12485.7,
    y1: -9838.48,
    y2: -9894.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#CA605A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#D86A5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ED7862"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F57D64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__u",
    x1: 168.835,
    x2: 168.835,
    y1: 104.353,
    y2: 196.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__x",
    x1: 243.128,
    x2: 243.747,
    y1: 180.62,
    y2: 172.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#523F0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#192B22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__y",
    x1: 266.315,
    x2: 258.417,
    y1: 142.531,
    y2: 152.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D97373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5957F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__z",
    x1: 8344.04,
    x2: 8540.82,
    y1: 10292.1,
    y2: 10321.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D97373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5957F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__A",
    x1: 243.251,
    x2: 245.761,
    y1: 177.904,
    y2: 144.734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#763F0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#522C0A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__B",
    x1: 245.071,
    x2: 243.776,
    y1: 151.118,
    y2: 171.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD6C31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#AC612A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#985423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8A4B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#82461B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#80441A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__C",
    x1: 248.267,
    x2: 250.046,
    y1: 164.83,
    y2: 186.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C816C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3BEAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__D",
    x1: 236.342,
    x2: 269.384,
    y1: 165.5,
    y2: 168.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE9A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6C1AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__E",
    x1: 236.455,
    x2: 269.497,
    y1: 164.04,
    y2: 166.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4AD99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD9C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__F",
    x1: 256.835,
    x2: 254.567,
    y1: 167.281,
    y2: 152.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAF0E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD9C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__G",
    x1: 255.802,
    x2: 256.584,
    y1: 173.873,
    y2: 163.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#533A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#211B16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__H",
    x1: 256.143,
    x2: 256.456,
    y1: 167.649,
    y2: 163.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#6E5540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B3929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__I",
    x1: -42008.3,
    x2: -41904.6,
    y1: -7114.42,
    y2: -7452.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#533A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#211B16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__J",
    x1: 211.718,
    x2: 232.827,
    y1: 144.427,
    y2: 143.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#522C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A4A0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__K",
    x1: 43812.7,
    x2: 43656.8,
    y1: 10955.1,
    y2: 9956.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#522C0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A4A0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__L",
    x1: 243.993,
    x2: 257.537,
    y1: 177.55,
    y2: 178.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4D0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E1CDBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__M",
    x1: -22455,
    x2: -22818.4,
    y1: -2599.47,
    y2: -2710.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4D0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E1CDBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__O",
    x1: 238.722,
    x2: 239.018,
    y1: 155.95,
    y2: 152.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33200E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__P",
    x1: 235.909,
    x2: 238.489,
    y1: 154.335,
    y2: 154.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C576E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D6E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__R",
    x1: -6407.97,
    x2: -6396.94,
    y1: -398.678,
    y2: -434.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33200E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643D1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__S",
    x1: -4532.88,
    x2: -4548.95,
    y1: -356.36,
    y2: -361.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C576E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#D6E4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "svg-2489810498__T",
    x1: 255.089,
    x2: 255.089,
    y1: 99.017,
    y2: 192.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-2489810498__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.347 71.995 91.737)scale(26.1226 18.6753)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F8471"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#877E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#726D62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575753"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-2489810498__h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.347 73.721 90.903)scale(7.19138)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E8AB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D69C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B98438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37F36"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-2489810498__i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.229 74.338 97.092)scale(3.68169 2.99628)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F806D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615E59"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-2489810498__j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(-20 -21940.727 -93370.488)scale(264.895 159.955)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E8AB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D69C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B98438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37F36"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-2489810498__m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(147.347 1902.73 7633.915)scale(117.188 44.6328)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F806D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#615E59"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-2489810498__o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-13.58812 8.70769 -7.551 -11.78314 177.236 127.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E9482"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#92897A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#716B63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65605B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-2489810498__N",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(4.327 -1925.986 3232.647)scale(2.9923 3.00434)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E8AB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D69C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B98438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37F36"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-2489810498__Q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-39.83873 -12.20578 10.05531 -32.81977 -10622.2 -1315.75)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEB04D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#E8AB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#D69C44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#B98438"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37F36"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-2489810498__V",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-.0594 23.08632 -28.5829 -.07353 227.093 92.017)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF957E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E71B18"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "svg-2489810498__X",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(72.733 -49.065 189.42)scale(43.6547)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD3BB"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "svg-2489810498__a",
    width: 193,
    height: 193,
    x: 124,
    y: 36,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1262_829",
    stdDeviation: 26
  })), /*#__PURE__*/React.createElement("filter", {
    id: "svg-2489810498__b",
    width: 148,
    height: 148,
    x: 64,
    y: 91,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_1262_829",
    stdDeviation: 26
  })), /*#__PURE__*/React.createElement("filter", {
    id: "svg-2489810498__c",
    width: 317.494,
    height: 317.494,
    x: 23,
    y: 15,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.902
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.264
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.458824 0 0 0 0 0.435294 0 0 0 0 0.423529 0 0 0 0.0522617 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.259
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.261
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.458824 0 0 0 0 0.435294 0 0 0 0 0.423529 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1262_829",
    result: "effect2_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.662
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.073
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.458824 0 0 0 0 0.435294 0 0 0 0 0.423529 0 0 0 0.0977383 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_1262_829",
    result: "effect3_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 42
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.458824 0 0 0 0 0.435294 0 0 0 0 0.423529 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_1262_829",
    result: "effect4_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect4_dropShadow_1262_829",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "svg-2489810498__v",
    width: 316.681,
    height: 316.681,
    x: 81.017,
    y: 41.017,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.902
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.264
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.458824 0 0 0 0 0.435294 0 0 0 0 0.423529 0 0 0 0.0522617 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_1262_829",
    result: "effect2_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.259
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.261
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.458824 0 0 0 0 0.435294 0 0 0 0 0.423529 0 0 0 0.075 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_1262_829",
    result: "effect3_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.662
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.073
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.458824 0 0 0 0 0.435294 0 0 0 0 0.423529 0 0 0 0.0977383 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_1262_829",
    result: "effect4_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 42
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.458824 0 0 0 0 0.435294 0 0 0 0 0.423529 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_dropShadow_1262_829",
    result: "effect5_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect5_dropShadow_1262_829",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "svg-2489810498__U",
    width: 356,
    height: 351,
    x: 49.017,
    y: 0.017,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.507
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.834
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.952941 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.342
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.952941 0 0 0 0 0 0 0 0 0 0 0 0 0 0.206994 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1262_829",
    result: "effect2_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.936
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.62
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.952941 0 0 0 0 0 0 0 0 0 0 0 0 0 0.166887 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_1262_829",
    result: "effect3_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 26.646
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.114
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.952941 0 0 0 0 0 0 0 0 0 0 0 0 0 0.133113 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_1262_829",
    result: "effect4_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 73
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 82.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.952941 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0930055 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_dropShadow_1262_829",
    result: "effect5_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect5_dropShadow_1262_829",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "svg-2489810498__W",
    width: 250.858,
    height: 250.858,
    x: 25.264,
    y: 120.649,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.301
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.769
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.85098 0 0 0 0 0.580392 0 0 0 0 0.435294 0 0 0 0.0465028 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.82
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.474
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.85098 0 0 0 0 0.580392 0 0 0 0 0.435294 0 0 0 0.0665564 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_1262_829",
    result: "effect2_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.873
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.126
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.85098 0 0 0 0 0.580392 0 0 0 0 0.435294 0 0 0 0.0834436 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_1262_829",
    result: "effect3_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24.456
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.798
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.85098 0 0 0 0 0.580392 0 0 0 0 0.435294 0 0 0 0.103497 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect3_dropShadow_1262_829",
    result: "effect4_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 67
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 51.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.85098 0 0 0 0 0.580392 0 0 0 0 0.435294 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect4_dropShadow_1262_829",
    result: "effect5_dropShadow_1262_829"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect5_dropShadow_1262_829",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "svg-2489810498__w"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 93.413,
    height: 93.413,
    x: 208.382,
    y: 99.017,
    fill: "#fff",
    rx: 20,
    transform: "rotate(17.035 208.382 99.017)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCat);
export default ForwardRef;